import React from 'react';
import RetailTradingInterface from '../components/trading/RetailTradingInterface';

const TradingBots: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <RetailTradingInterface />
    </div>
  );
};

export default TradingBots;
